import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m19.107 9.157-3.554 3.554 1.422 1.421 3.553-3.553a5.025 5.025 0 1 0-7.107-7.107L9.868 7.025l1.421 1.422 3.554-3.554a3.015 3.015 0 0 1 4.264 4.264ZM3.472 13.421l3.553-3.553 1.422 1.421-3.554 3.554a3.015 3.015 0 0 0 4.264 4.264l3.554-3.554 1.421 1.422-3.553 3.553a5.025 5.025 0 1 1-7.107-7.107Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m16.264 9.157-7.107 7.107-1.421-1.421 7.107-7.107 1.421 1.421Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }